var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.127481 9.59995C0.127481 9.25584 0.258867 8.91178 0.521087 8.64944L8.77674 0.393871C9.3019 -0.13129 10.1534 -0.13129 10.6783 0.393871C11.2033 0.918821 11.2033 1.77011 10.6783 2.29531L3.37325 9.59995L10.6781 16.9046C11.203 17.4298 11.203 18.281 10.6781 18.8059C10.1531 19.3313 9.30165 19.3313 8.77648 18.8059L0.520831 10.5505C0.258569 10.288 0.127481 9.94392 0.127481 9.59995Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.200e48732947e1ec3cc194d64e31709a.svg";
export { ForwardRef as ReactComponent };